<template>
  <validation-observer
    v-if="showAdvancedMotorist"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="advanced-motorist"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row label="Are you a member of the Institute of Advanced Motorists?">
        <validation-provider
          v-slot="{ failed }"
          :data-unit-test="`${stepId}_advanced-motorist`"
          :vid="`${stepId}_advanced-motorist`"
          name="Member of the IAM"
          :rules="{ required: showAdvancedMotorist }"
        >
          <radio
            v-model="questionData.advancedMotorist"
            :name="`${stepId}.advanced-motorist`"
            :data-test="snakeCase(questionFields.advancedMotorist)"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
// TODO make common
import * as payloadTemplates from '@/payloadTemplates/car';
import QuestionBase from './Base';

export default {
  name: 'question-advanced-motorist',
  extends: QuestionBase,
  data () {
    return {
      fields: ['advancedMotorist'],
    };
  },
  created () {
    this.$watch('showAdvancedMotorist', val => {
      if (this.isAdditional) return;

      this.questionData.advancedMotorist = val ? payloadTemplates.DRIVER.advancedMotorist : null;
    });
  },
  computed: {
    showAdvancedMotorist () {
      return !this.isAdditional && this.stepData?.typeOfDriving === 'F';
    },
  },
};
</script>
